import _toConsumableArray from "/var/lib/jenkins/workspace/goforit-web-dealer-prod/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/var/lib/jenkins/workspace/goforit-web-dealer-prod/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/lib/jenkins/workspace/goforit-web-dealer-prod/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/createClass";
import pointRadial from "../pointRadial.js";
var Bump = /*#__PURE__*/function () {
  function Bump(context, x) {
    _classCallCheck(this, Bump);
    this._context = context;
    this._x = x;
  }
  _createClass(Bump, [{
    key: "areaStart",
    value: function areaStart() {
      this._line = 0;
    }
  }, {
    key: "areaEnd",
    value: function areaEnd() {
      this._line = NaN;
    }
  }, {
    key: "lineStart",
    value: function lineStart() {
      this._point = 0;
    }
  }, {
    key: "lineEnd",
    value: function lineEnd() {
      if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
      this._line = 1 - this._line;
    }
  }, {
    key: "point",
    value: function point(x, y) {
      x = +x, y = +y;
      switch (this._point) {
        case 0:
          {
            this._point = 1;
            if (this._line) this._context.lineTo(x, y);else this._context.moveTo(x, y);
            break;
          }
        case 1:
          this._point = 2;
        // falls through
        default:
          {
            if (this._x) this._context.bezierCurveTo(this._x0 = (this._x0 + x) / 2, this._y0, this._x0, y, x, y);else this._context.bezierCurveTo(this._x0, this._y0 = (this._y0 + y) / 2, x, this._y0, x, y);
            break;
          }
      }
      this._x0 = x, this._y0 = y;
    }
  }]);
  return Bump;
}();
var BumpRadial = /*#__PURE__*/function () {
  function BumpRadial(context) {
    _classCallCheck(this, BumpRadial);
    this._context = context;
  }
  _createClass(BumpRadial, [{
    key: "lineStart",
    value: function lineStart() {
      this._point = 0;
    }
  }, {
    key: "lineEnd",
    value: function lineEnd() {}
  }, {
    key: "point",
    value: function point(x, y) {
      x = +x, y = +y;
      if (this._point === 0) {
        this._point = 1;
      } else {
        var _this$_context, _this$_context2;
        var p0 = pointRadial(this._x0, this._y0);
        var p1 = pointRadial(this._x0, this._y0 = (this._y0 + y) / 2);
        var p2 = pointRadial(x, this._y0);
        var p3 = pointRadial(x, y);
        (_this$_context = this._context).moveTo.apply(_this$_context, _toConsumableArray(p0));
        (_this$_context2 = this._context).bezierCurveTo.apply(_this$_context2, _toConsumableArray(p1).concat(_toConsumableArray(p2), _toConsumableArray(p3)));
      }
      this._x0 = x, this._y0 = y;
    }
  }]);
  return BumpRadial;
}();
export function bumpX(context) {
  return new Bump(context, true);
}
export function bumpY(context) {
  return new Bump(context, false);
}
export function bumpRadial(context) {
  return new BumpRadial(context);
}